import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import Grid from "../components/atoms/grid"
import Heading from "../components/atoms/heading"
import Wrapper from "../components/atoms/wrapper"
import Seo from "../components/head"
import Layout from "../components/layout"
import Card from "../components/molecules/card"
import Sidebar from "../components/organisms/sidebar"
import CardMapping from "../helpers/card-mapping"

const GuidesGlossariesFaqs = ({ data, pageContext }) => {
  const regionGuides = data.guides.nodes.filter(
    (post) =>
      post.country === null || post.country.abbreviation === process.env.GATSBY_COUNTRY
  )
  return (
    <Layout>
      <Wrapper container spacer>
        <Heading>
          {
            data.allSanityDictionary.nodes.find(
              (item) => item.key.current === "guides_glossaries_faqs"
            )?.value
          }
        </Heading>
        {regionGuides.slice(0, 1).map((item) => (
          <div key={item.title}>
            <Card
              article={CardMapping(item)}
              variant="primary_feature"
              color="chartruse"
            />
          </div>
        ))}
        <Grid col={3}>
          {regionGuides.slice(2).map((item) => (
            <div key={item.title}>
              <Card article={item} />
            </div>
          ))}
        </Grid>
      </Wrapper>
      <Sidebar
        color="bloodorange"
        title="learn_more"
        secondaryTitle={
          data.allSanityDictionary.nodes.find(
            (item) => item.key.current === "faq"
          )?.value
        }
        sidebar={data.faqs.nodes}
      />
      <Sidebar
        color="sky"
        title="learn_more"
        secondaryTitle={
          data.allSanityDictionary.nodes.find(
            (item) => item.key.current === "glossary"
          )?.value
        }
        sidebar={data.glossaries.nodes}
      />
    </Layout>
  )
}

GuidesGlossariesFaqs.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default GuidesGlossariesFaqs

const HeadComponent = ({ data, location }) => (
  <Seo
    title={
      data.allSanityDictionary.nodes.find(
        (item) => item.key.current === "guides_glossaries_faqs"
      )?.value
    }
    path={location.pathname}
  />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const GuidesGlossariesFaqsQuery = graphql`
  query ggfQuery {
    allSanityDictionary {
      nodes {
        key {
          current
        }
        value
      }
    }
    guides: allSanityArticle(
      filter: {
        web_article_type: { eq: "guide" }
        publishing: { in: "website" }
      }
      sort: { date: DESC }
    ) {
      nodes {
        id
        title
        abstract
        detailed_title
        sport {
          name
          slug {
            current
          }
        }
        featured_image {
          image {
            ...ImageWithPreview
          }
        }
        country {
          abbreviation
        }
        web_article_type
        slug {
          current
        }
      }
    }
    faqs: allSanityFaqGlossary(
      filter: { type: { eq: "faq" } }
      sort: { sport: { name: ASC } }
    ) {
      nodes {
        id
        sport {
          name
          slug {
            current
          }
        }
        featured_image {
          ...ImageWithPreview
        }
        type
      }
    }
    glossaries: allSanityFaqGlossary(
      filter: { type: { eq: "glossary" } }
      sort: { sport: { name: ASC } }
    ) {
      nodes {
        id
        sport {
          name
          slug {
            current
          }
        }
        featured_image {
          ...ImageWithPreview
        }
        type
      }
    }
  }
`
